module.exports = __webpack_public_path__ + "assets/14814a0f8045a0ee22a55622c80c7bc4.mp3";